import { useContext } from 'react';

import { BusinessDataContext } from '@/context';

export const useBusinessData = () => {
  const context = useContext(BusinessDataContext);
  if (context === null) {
    throw new Error('useBusinessData must be used within a BusinessDataProvider');
  }
  return context;
};
